
    var riot = require('riot')
    
riot.tag2('suppliers-quote', '<form method="POST" action="/duocms/api/quotes/uploadpdf/{opts.id}/{opts.token}?_csrf={opts.csrf}" enctype="multipart/form-data" class="form-horizontal form-upload"> <div class="caption"><strong>Upload quotation</strong><span>&nbsp;- upload pdf / document quotation here</span></div> <div class="row"> <div class="col-xs-12"> <div class="grey"> <div class="form-group"> <label class="control-label col-xs-12 col-sm-3 col-md-2 nopadtop"> Upload Quote</label> <div class="col-xs-12 col-sm-9 col-md-10"> <input type="file" name="file"> </div> </div> </div> </div> </div> <div class="row"> <div class="col-xs-12 btnrow"> <div class="row"> <div class="col-xs-12 col-sm-6 col-md-4 col-sm-push-6 col-md-push-8 nopadleft"> <button type="submit" class="btn btn-primary btn-block">Upload Quote</button> </div> </div> </div> </div> </form> <hr class="white"> <div class="text-center">OR</div> <hr class="white"> <form onsubmit="{sendQuote}" class="form-horizontal form-upload"> <div class="caption"><strong>Online Quotation Form</strong></div> <div each="{item,i in items}" class="row"> <div class="col-xs-12 col-sm-6 col-md-8"> <div class="form-group"> <div class="col-xs-12"> <p class="form-control-static"> <strong>Title: </strong>{item.title}</p> </div> </div> <div class="form-group"> <div class="col-xs-12"> <p class="form-control-static"><strong>Description: <br></strong><span riot-tag="raw" content="{item.description_text}"></span></p> </div> </div> </div> <div class="col-xs-12 col-sm-6 col-md-4 nopadleft"> <div class="grey padleft"> <div class="form-group"> <div class="row"> <label class="col-xs-3"><strong>Quantity: </strong></label> <div class="col-xs-9">{item.quantity}</div> </div> </div> <forminput label="&amp;pound;" width1="3" width2="9" isrequired name="{item.id}" onupdate="{setItemPrice}"></forminput> <formtextarea label="Notes" width1="3" width2="9" name="{item.id}" onupdate="{setItemNotes}"></formtextarea> </div> </div> <hr show="{i &lt; parent.items.length-1}" class="col-xs-8 col-xs-offset-2"> </div> <div class="row"> <div class="col-xs-12 btnrow"> <div class="row"> <div class="col-xs-12 col-sm-6 col-md-4 col-sm-push-6 col-md-push-8 nopadleft"> <button type="submit" class="btn btn-primary btn-block">Send Quote</button> </div> </div> </div> </div> </form>', 'suppliers-quote hr.white { border-color: #fff; } suppliers-quote .grey { background: #eee; padding-top: 15px; padding-bottom: 15px; } suppliers-quote .grey.padleft { padding-left: 15px; } suppliers-quote .input-group .form-control { float: right; } suppliers-quote .input-group-addon { background: none; border: none; } suppliers-quote .form-upload { border: 1px solid #e1e1e1; } suppliers-quote .form-upload .form-group { margin: 0; } suppliers-quote .form-upload .col-xs-12 { padding-left: 15px; padding-right: 15px; } suppliers-quote .form-upload .nopadleft { padding-left: 0; } suppliers-quote .form-upload .nopadtop { padding-top: 0; } suppliers-quote .form-upload .caption { font-size: 21px; display: block; padding: 10px 15px; border-bottom: 1px solid #eee; } suppliers-quote .form-upload .caption span { font-size: 16px; } suppliers-quote .form-upload formtextarea .form-group { margin-top: 10px; } suppliers-quote .form-upload formtextarea textarea { background: #fff; } @media (max-width: 767px) { suppliers-quote .form-upload .btn-primary { display: block; width: 100%; } suppliers-quote .form-upload .nopadleft { padding-left: 15px; } }', '', function(opts) {
var quoteApi, resource;

resource = require('riot-kit/utils/apiResource.coffee');

quoteApi = new resource('/duocms/api/quotes', true);

this.on('mount', function() {
  this.items = opts.quote.items.map(function(i) {
    var ref;
    return Object.assign(i, {
      description_text: (ref = i.description) != null ? ref.replace(/[\n\r]/g, '<br/>') : void 0
    });
  });
  return this.update();
});

this.setItemPrice = (function(_this) {
  return function(e) {
    return _this.items = _this.items.map(function(i) {
      if (i.id === +e.name) {
        i.price = e.value;
      }
      return i;
    });
  };
})(this);

this.setItemNotes = (function(_this) {
  return function(e) {
    return _this.items = _this.items.map(function(i) {
      if (i.id === +e.name) {
        i.notes = e.value;
      }
      return i;
    });
  };
})(this);

this.sendQuote = (function(_this) {
  return function() {
    return quoteApi.save({
      id: opts.quote.id,
      items: _this.items.map(function(i) {
        return Object.assign({}, {
          id: i.id,
          price: i.price,
          notes: i.notes
        });
      })
    }, function(data, err) {
      if (err != null) {
        console.log(err);
      }
      if (err == null) {
        window.location.pathname = '/supplier_quote/thank_you';
      }
      return null;
    });
  };
})(this);
});
    
  